export const RECOMMENDED_PRODUCTS_CAROUSEL_COMPONENT_NAME = 'recommended-products-carousel';

export const RECOMMENDED_PRODUCTS_CAROUSEL_IMAGE_VIEWPORT_SETTINGS = {
    xs: { w: 285, h: 380 },
    sm: { w: 285, h: 380 },
    md: { w: 285, h: 380 },
    lg: { w: 285, h: 380 },
    xl: { w: 285, h: 380 }
};
